<template lang="pug">
  main#main.manager-categories
    b-container(fluid)
      wc-breadcrumb(icon='fal fa-layer-group')
      section.l-section
        .l-section-h
          router-view
</template>

<script>
import WcBreadcrumb from '@components/shared/WcBreadcrumb'

export default {
  name: 'manager-categories',
  components: {
    WcBreadcrumb,
  },
}
</script>
